export const pages = [
  { title: "Employee", route: "employee", role: ["ADMIN", "STAFF"] },
  {
    title: "Facility",
    route: "facility",
    role: ["ADMIN", "STAFF"],
    subpages: [
      { title: "Facility", route: "facility", role: ["ADMIN", "STAFF"] },
      {
        title: "Wards/Sub wards",
        route: "subfacility",
        role: ["ADMIN", "STAFF"],
      },
    ],
  },
  { title: "Employee Info", route: "infofield", role: ["ADMIN", "STAFF"] },
  { title: "Timesheet", route: "timesheet", role: ["ADMIN", "STAFF"] },
  { title: "Worktype", route: "worktype", role: ["ADMIN", "STAFF"] },

  { title: "Schedule", route: "schedule", role: ["ADMIN", "STAFF"] },
  //{ title: 'Schedule', route: 'schedule', 'role': ['STAFF'] },
  //{ title: 'Reports', route: 'reports', 'role': ['ADMIN'] },
];
export const settings = [
  /*  { title: 'Profile', route: 'profile', 'role': ['USER'] },
    { title: 'Account', route: 'account', 'role': ['USER'] }, */
  { title: "Dashboard", route: "dashboard", role: ["USER"] },
];
